import React from "react";
import { Button, Image } from "react-bootstrap";

import "./CircularButton.scss";

type ICircularButtonProps = {
  color?: string;
  onClick?: () => void;
  disabled?: boolean;
  image: string | React.ReactNode;
  imageClass?: string;
  buttonClass: string;
};

function CircularButton({
  color,
  onClick,
  disabled,
  image,
  imageClass = "",
  buttonClass = "",
}: ICircularButtonProps) {
  const ButtonStyle = {
    background: color,
  };

  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      className={`${buttonClass} CircularButton`}
      style={ButtonStyle}
    >
      {typeof image === "string" ? (
        <Image
          className={`${imageClass} circular-img`}
          src={image}
          alt="circular_image"
        />
      ) : (
        <span className={`${imageClass} circular-img`}>{image}</span>
      )}
    </Button>
  );
}

export default CircularButton;
